import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class SupportTableDataDTO extends DataTransferObject {

    public Columns: Array<any>;

    public DataElements: Array<any>;

    public RemoteTypeName: string;

    public AllowedDuplicated: boolean;

    constructor() {
        super({ xmlProperties: ['Columns', 'DataElements', 'RemoteTypeName'], xmlNamespace: 'ISMS.DataTransfer' });

        this.Columns = this.defaultFromType('array');
        this.DataElements = this.defaultFromType('array');
        this.RemoteTypeName = this.defaultFromType('string');
        this.AllowedDuplicated = this.defaultFromType('bool');
    }
}

ComponentManager.setModel('SupportTableDataDTO', SupportTableDataDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');